/* unplugin-vue-components disabled */import { defineComponent as _defineComponent } from 'vue';
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import useEcharts from '../hooks/useEcharts';
// import type { EChartsOption } from 'echarts';
// import type { ECOption } from '../hooks/useEcharts';
export default /*#__PURE__*/_defineComponent({
  __name: 'base-echart',
  props: {
    width: {
      default: '100%'
    },
    height: {
      default: '360px'
    },
    options: {}
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    __expose({
      getEchartWidth: getEchartWidth
    });
    var props = __props;
    var _toRefs = toRefs(props),
      options = _toRefs.options;
    var echartRef = ref();
    var echartIns = ref();
    function getEchartWidth() {
      return echartIns.value ? echartIns.value.getWidth() : 0;
    }
    onMounted(function () {
      nextTick(function () {
        if (_.isUndefined(echartRef.value)) return;
        var _useEcharts = useEcharts(echartRef.value),
          setOption = _useEcharts.setOption,
          echartInstance = _useEcharts.echartInstance;
        echartIns.value = echartInstance;
        watchEffect(function () {
          setOption(options.value);
        });
      });
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "echartRef",
        ref: echartRef,
        style: _normalizeStyle({
          width: _ctx.width,
          height: _ctx.height
        })
      }, null, 4);
    };
  }
});